import { render, staticRenderFns } from "./publishPage.vue?vue&type=template&id=7892f5a2&scoped=true&"
import script from "./publishPage.vue?vue&type=script&lang=js&"
export * from "./publishPage.vue?vue&type=script&lang=js&"
import style0 from "./publishPage.vue?vue&type=style&index=0&id=7892f5a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7892f5a2",
  null
  
)

export default component.exports